module.exports = __webpack_public_path__ + "static/img/point_2.5851b9d1.png";